import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Products } from "@/components/site/Products";
import { Shipping } from "@/components/site/Shipping";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { SalesPopup } from "@/components/site/SalesPopup";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (id.length < 2) return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -74 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App relative bg-bg text-ink font-body">
            <div className="grain-overlay" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <WhyChooseUs />
                <Products />
                <Shipping />
                <Testimonials />
                <FAQ />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <SalesPopup />
        </div>
    );
}

export default App;
